import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class MaterialDemandPositionDbTableDefinition extends DbTableDefinition {
  tableName = 'materialdemandposition';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
      databag LONGTEXT,
      label TEXT,
      materialdemandid BIGINT(20),
      materialdemandlabel TEXT  ,
      materialdescription TEXT,
      posstatus TEXT,
      comment TEXT,
      amount DOUBLE,
      materialdeliveryid BIGINT(20),
      materialdeliverylabel TEXT,
      materialid BIGINT(20),
      materiallabel TEXT
    );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    this.updateStatements.set(18, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);

    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'drawingparttnbr',
        type: 'VARCHAR(255)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'dlvinfopalletnbr',
        type: 'VARCHAR(35)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'dlvinfoloadingorder',
        type: 'VARCHAR(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'dlvinfocomment',
        type: 'VARCHAR(255)',
      });
    } else {
      this.updateStatements.set(19, [
        `ALTER TABLE ${this.tableName} ADD COLUMN drawingparttnbr VARCHAR(255);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN dlvinfopalletnbr VARCHAR(35);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN dlvinfoloadingorder VARCHAR(20);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN dlvinfocomment VARCHAR(255);`,
      ]);
    }
  }
}
